/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx';
import qs from 'qs';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import undoIcon from '../../../assets/images/Undo-Arrow.svg';
import refreshIcon from '../../../assets/images/refresh.png';
import { getUpdatedParams, getSelectedInfo, getSelectedOption } from '../../../utils/commonRingUtils';
import AppTabs from '../../components/AppTabs';
import If from '../../components/If';
import Loader from '../../components/Loader';
import MyGallery from '../../components/MyGallery';
import { ITab, ITabs } from '../../types/customizer';
import { getPageData } from './Pages';
import DesktopSidebar, { handleLogoClick } from "../../components/Sidebar/DesktopSidebar";
import MobileSidebar from "../../components/Sidebar/MobileSidebar";
import leftArrow from '../../../assets/images/left-chevrolet.svg';
import CartIcon from '../../../assets/images/cart-icon.svg';
import ReverseIcon from '../../../assets/images/contrast.png';
import listIcon from "../../../assets/images/list-icon.svg";

import { useRingCustomizerContext } from '../../context/RingCustomizerContext';
import RingCustomizerHOC, { IParams } from '../../components/RingCustomizerHOC';
import RingCustomizerLayout from '../../layouts/RingCustomizerLayout';
import { APP_STYLES, DEFAULT_STYLES } from '../../../utils/basic';
import AppModal from '../../components/AppModal';
import { formatSummaryDate, getLastestShippingDate, getLastestShippingDateHenne } from '../../components/Summary';
import DiscountedPopup from '../../components/DiscountedPopup';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { RootState } from '../../../redux/store';
import { compareParams } from '../../../utils/helper';
import { toast } from 'react-toastify';
import { IAddBestSellerToCartPayload, getScreensaverData } from '../../../redux/actions/customizer';
import { addBestSellerToCart } from '../../../redux/actions/customizer';
import LegacyTouchIntroModal from "../../components/LegacyTouchIntro";
import './index.scss';
import KayDiscountedPopup from '../../components/KayDiscountedPopup';

const SCREENSAVER_CONFIG = {
  ENABLE_FOR_ALL_USERS: true,
  FADE_DURATION: 500,
};

const RingCustomizer = () => {
  const [pages, setPages] = useState<ITabs>([]);
  const [key, setKey] = useState<string>('');
  const [open, setOpen] = useState<boolean>(false)
  const [myHistory, setMyHistory] = useState<string[]>(() => {
    const list = sessionStorage.getItem('myHistory');
    return list ? JSON.parse(list) : [];
});

const location = useLocation();
const navigate = useNavigate();

  const {
    product,
    params,
    url,
    type,
    isQueryHandling,
    handleLegacyAddToCart,
    handleAddToCart,
    handleDone,
    subpath,
    storeData,
    isLoading,
    redirectToPDP
  } = useRingCustomizerContext();
  const dispatch = useAppDispatch();
  const { bestSellerProduct: bProduct, screensaverData } = useAppSelector((state: RootState) => state.customizer);

  const [discountOpen, setDiscountOpen] = useState<boolean>(false);
  const [size, setSize] = useState(10);
  const [engraving, setEngraving] = useState<string>('');
  const [bestSellerId, setBestSellerId] = useState<string>('');
  const [inactivityModalOpen, setInactivityModalOpen] = useState<boolean>(false);
  const [isFading, setIsFading] = useState<boolean>(false);
  const inactivityTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isBestSellerLoading, setIsBestSellerLoading] = useState<boolean>(false);

  const initialParamsRef = useRef<IParams>(params);
  useEffect(() => {
    const { pathParams: initialPathParams, queryParams: initialQueryParams } = initialParamsRef.current;
    if (Object.keys(initialPathParams).length === 0 && Object.keys(initialQueryParams).length === 0) {
      initialParamsRef.current = { pathParams: { ...params.pathParams }, queryParams: { ...params.queryParams } };
    }
  }, [params]);

  useEffect(() => {
    console.log('>>>>>>OTHER QUERY PARAMS>>>>>>>>>>>>>>>>>>>>>>>>>', params.otherQueryParams);
    if(params.otherQueryParams?.bestSeller) {
      setBestSellerId(params.otherQueryParams?.bestSeller);
      if(params.otherQueryParams?.bSize) {
        setSize(parseInt(params.otherQueryParams?.bSize));
      }
      if(params.otherQueryParams?.bEngraving) {
        setEngraving(params.otherQueryParams?.bEngraving);
      }
      setDiscountOpen(true);
    }
  }, [params.otherQueryParams]);

  useEffect(() => {
    dispatch(getScreensaverData({ subpath: subpath || null }));
  }, []);

  useEffect(() => {
    return () => {
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
    };
  }, []);

  const resetInactivityTimer = useCallback(() => {
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
    }
    if (inactivityModalOpen) return;
    const shouldEnable = SCREENSAVER_CONFIG.ENABLE_FOR_ALL_USERS;
    if (!shouldEnable) return;
    if (!screensaverData?.active || !screensaverData?.video_path) return;
    const secs = screensaverData.time_in_seconds ?? 0;
    if (!secs || secs <= 0) return;
    const timeoutMs = secs * 1000;
    inactivityTimerRef.current = setTimeout(() => {
      setIsFading(true);
      setTimeout(() => {
        setInactivityModalOpen(true);
        setIsFading(false);
        setTimeout(() => videoRef.current?.play().catch(console.error), 0);
      }, SCREENSAVER_CONFIG.FADE_DURATION);
    }, timeoutMs);
  }, [inactivityModalOpen, screensaverData]);

  const closeInactivityModal = useCallback(() => {
    setIsFading(true);
    setTimeout(() => {
      setInactivityModalOpen(false);
      setIsFading(false);
      resetInactivityTimer();
    }, SCREENSAVER_CONFIG.FADE_DURATION);
  }, [resetInactivityTimer]);

  useEffect(() => {
    resetInactivityTimer();
    const handleActivity = () => {
      if (inactivityModalOpen) closeInactivityModal();
      else resetInactivityTimer();
    };
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('mousedown', handleActivity);
    window.addEventListener('keypress', handleActivity);
    window.addEventListener('scroll', handleActivity);
    window.addEventListener('touchstart', handleActivity);
    window.addEventListener('click', handleActivity);
    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('mousedown', handleActivity);
      window.removeEventListener('keypress', handleActivity);
      window.removeEventListener('scroll', handleActivity);
      window.removeEventListener('touchstart', handleActivity);
      window.removeEventListener('click', handleActivity);
      if (inactivityTimerRef.current) clearTimeout(inactivityTimerRef.current);
    };
  }, [inactivityModalOpen, resetInactivityTimer, closeInactivityModal]);

  useEffect(() => {
    const { subpath, productHandle } = params.pathParams;
    if(productHandle && subpath === 'customize') {
      viewedProduct(productHandle);
    }
  }, [params.pathParams]);

  useEffect(() => {
    if(product) {
      const pages = product ? getPageData({
        product,
        type,
        subpath,
        storeData,
        ring_type: params.pathParams.ring_type,
        isBuildFromScratch: params?.queryParams?.isBuildFromScratch === 'true'
      }) : [];
      const activekey = getActiveTab(pages);
      setPages(pages);
      if(!key) {
        setKey(activekey);
      }
    }
  }, [product])

  useEffect(() => {
    if(product) {
      /**
       * Check currenturl with data.ring_options_url, if diffreent load `data.ring_options_url`
       */
      const ringOptionUrl = product.ring_options_url;
      if(ringOptionUrl !== url.ring_url) {
        navigateToUrl(ringOptionUrl, true); // Replace last URL
      } else {
        const { productHandle } = params.pathParams;
        if(!productHandle) {
          /**
           * Set klavio tracking whenever new data with following criteria
           * 1. data gets changes
           * 2. ringOptionUrl === url.ring_url
           * 3. when there is no `productHandle`
           */
          console.log('>>>>>>KLAVIO TRACKING');
          addViewedKlavioTracking();
        }
      }
    }
  }, [product])

  const addViewedKlavioTracking = () => {
    if(!product) {
      return;
    }
    var _learnq: any = (window as any)._learnq || [];
    const item = {
      Brand: 'Emblem Custom',
      Name: product.description,
      ProductID: product.sku,
      URL: window.location.href,
      price: product.price,
      ImageURL: `${process.env.REACT_APP_ASSET_URL}${product.images[0]}`
    }
    _learnq.push(['track', 'Viewed Product', item]);
  }

  const fetchProduct = (handle: string) => {
    return fetch(`/products/${handle}.js`).then(async res => {
      if(res.ok) {
        return res.json();
      } else {
        const text = await res.text();
        throw new Error(text);
      }
    });
  }

  const viewedProduct = async (productHandle: string) => {
    if(process.env.REACT_APP_ENVIRONMENT !== 'production') {
      return;
    }

    const product = await fetchProduct(productHandle);
    console.log({ response: product });

    var _learnq: any = (window as any)._learnq || [];
    const item = {
      Brand: 'Emblem Custom',
      Name: product.title,
      ProductID: product.id,
      URL: window.location.href,
      price: product.price / 100,
      ImageURL: `https://${product.featured_image}`,
      CompareAtPrice: product.compare_at_price || 0,
    }
    _learnq.push(['track', 'Viewed Product', item]);
  }

  const handleUrlChange = (params: { urlParams: any, queryParams: any }) => {
    let URL = '';
    if(type === 1) {
      const { urlParams: { profile, width, ring_materials }, queryParams } = params;
      const searchString = qs.stringify(queryParams);
      URL = `/rings/profiles/${profile}/widths/${width}/ring_materials/${ring_materials}?${searchString}`;
    } else if(type === 2) {
      const { urlParams: { styles, ring_materials, color_arrangements, stone_quantities, variants }, queryParams } = params;
      const searchString = qs.stringify(queryParams);
      URL = `/women/rings/styles/${styles}/ring_materials/${ring_materials}/color_arrangements/${color_arrangements}/stone_quantities/${stone_quantities}/variants/${variants}?${searchString}`
    } else if (type === 3) {
      const { urlParams: { ring_type, ring_materials}, queryParams } = params;
      const searchString = qs.stringify(queryParams);
      URL = `/rings/${ring_type}/ring_materials/${ring_materials}?${searchString}`;
  }
    addHistory();
    navigateToUrl(URL, false); // push new URL
  }

  const navigateToUrl = (URL: string, replace = true, bestSeller?: string) => {
    const { pathprefix, subpath } = params.pathParams;
    let navigateUrl = URL;
    if(pathprefix && subpath) {
      navigateUrl = `/${pathprefix}/${subpath}${URL}`;
    } else if(subpath){
      navigateUrl = `/${subpath}${URL}`;
    }

    if(isQueryHandling) {
      navigateUrl = `${location.pathname}?ring_url=${encodeURIComponent(navigateUrl)}`;
    }

    let otherQueryParams = { ...params.otherQueryParams };
    if(bestSeller) {
      otherQueryParams = { ...otherQueryParams, bestSeller: bestSeller };
    }
    const otherQueryString = new URLSearchParams(otherQueryParams).toString();
    if(otherQueryString) {
      navigateUrl += `&${otherQueryString}`;
    }
    navigate(navigateUrl, { replace: replace }); // After URL is navigated it calls a useffect of location dependencies
  }

  const handleUpdate = (tobeUpdated: any) => {
    const paramsData = {
      urlParams: params.pathParams,
      queryParams: params.queryParams
    }
    const updatedParams = getUpdatedParams(tobeUpdated, paramsData)
    handleUrlChange(updatedParams);
  }

  const getActiveTab = (items: ITab[]) => {
    const selectedTab = items.find(tab => tab.isSelected);
    let key = '';
    if(selectedTab) {
      key = selectedTab.eventKey;
    } else {
      key = items?.[0]?.eventKey || '';
    }
    return key;
  }

  const toggleOpen = () => {
    setOpen(!open)
  }

  const handleActiveTab = (key: string, toggleVisibility: boolean) => () => {
    setKey(key);
    if(toggleVisibility) {
      toggleOpen();
    }
  }

  const addHistory = () => {
    const URL = url.ring_url;
    const list = [...myHistory, URL];
    sessionStorage.setItem('myHistory', JSON.stringify(list));
    setMyHistory(list);
  };

  const removeHistory = () => {
    const cloned = myHistory.slice();
    cloned.pop();
    sessionStorage.setItem('myHistory', JSON.stringify(cloned));
    setMyHistory(cloned);
  };

  const handleReset = () => {
    navigateToUrl(myHistory[0]);
    sessionStorage.removeItem('myHistory');
    setMyHistory([]);
  };

  const handleUndo = () => {
    if(myHistory.length) {
      navigate(-1);
      removeHistory();
    }
  }

  const handleBestSellerDone = async () => {
    const payload: IAddBestSellerToCartPayload = {
      data: {
        bestseller_id: bestSellerId,
        size: size,
        engraving: engraving,
        subpath: subpath,
        summaryContent: document.getElementById('summaryContent')?.outerHTML,
        intergration_url: `https://${storeData?.base_url}lashbrook-redesign?ring_url=${encodeURIComponent(`/apps/${storeData?.subpath}${bProduct?.ring_options_url}`)}`,
        ring_url: bProduct?.ring_options_url,
        magic_number: bProduct?.magic_number,
        currencyCode: storeData?.currency || 'USD',
      }
    }
    try {
      console.log('>>>>>>PAYLOAD>>>>>>>>>>>>>>>>>>>>>>>>>', payload);
      setIsBestSellerLoading(true);
      const response = await dispatch(addBestSellerToCart(payload));
      await redirectToPDP(response.payload);
    } catch (error) {
      console.log('>>>>>>ERROR>>>>>>>>>>>>>>>>>>>>>>>>>', error);
    } finally {
      setIsBestSellerLoading(false);
    }
  }

  const [acknowledged, setAcknowledged] = useState(false);

  type SizeOption = {
    name: string;
    selected: boolean;
    sku: string;
    swatch_url: string | null;
    type: 'option' | string;
    value: string;
  };

  type Product = { size?: SizeOption[] };

  const selectedSize =
    (product as Product)?.size?.find(o => o.selected) ?? null;

  const renderTopBar = () => {
  	const styles = APP_STYLES[subpath] || DEFAULT_STYLES;
    return (
      <>
        <If condition={['customize'].includes(subpath)} >
          <div className='tw-flex tw-items-center tw-justify-between tw-px-3 tw-h-13 tw-w-full tw-top-0 tw-bg-secondary-bg-color sm:tw-hidden secondary-font-family'>
            <div className='tw-pl-1.5 tw-text-black tw-underline tw-text-sm' onClick={handleDone}>
              <img src={leftArrow} alt="right_arrow" className="tw-inline-block tw-mb-1" /> Done
            </div>
            <button className="tw-bg-red tw-text-white tw-px-9 tw-py-2 tw-rounded-full" onClick={handleAddToCart}>Add to Cart - {product?.price}</button>
            <a href="/cart"><img src={CartIcon} alt="cart_icon" className="tw-pl-3 tw-w-10" /></a>
          </div>
        </If>
        <If condition={!['customize'].includes(subpath)}>
          <If condition={!['legacy-touch', 'legacy-touch-dev'].includes(subpath)}>
            <div className={clsx("tw-m-2 sm:tw-hidden mobile_logo_section", subpath)}>
              <div className="tw-w-36 tw-inline-block mobile_logo_container" onClick={handleLogoClick}>
                <img className="brand-logo" alt="brand_logo"/>
              </div>
            </div>
          </If>
          <If condition={(styles.showShippingEstimation || styles.enableDefaultDone) && !['kay-jewelers', 'diamonds-direct'].includes(subpath)}>
            <div className={clsx('tw-flex tw-items-center tw-justify-between tw-px-3 tw-h-13 tw-w-full tw-top-0 tw-bg-primary-bg-color sm:tw-hidden')}>
              <If condition={styles.showShippingEstimation}>
                <div className='tw-text-center tw-text-sm'>
                  <If condition={subpath != 'happy-jewelers'}>
                      <div>Ships as soon as:</div>
                  </If>
                  <If condition={['happy-jewelers'].includes(subpath)}>
                    <div>Ships directly to Happy Jewelers as soon as:</div>
                  </If>
                  <If condition={subpath != 'henne'}>
                    <div className='tw-font-bold'>{getLastestShippingDate(product?.shipping_options)}</div>
                  </If>
                  <If condition={['henne'].includes(subpath)}>
                    <div className='tw-font-bold'>{getLastestShippingDateHenne(product?.shipping_options)}</div>
                  </If>
                </div>
              </If>
              <If condition={styles.enableDefaultDone}>
                <button className={`!tw-bg-brand-color !tw-text-white ${product?.msrp ? 'tw-px-10' : 'tw-px-4'} tw-py-2 tw-text-sm secondary-font-family tw-rounded-tertiary-border-radius`} onClick={handleDone}>
                  {['johnAtencio', 'johnAtencio-stage'].includes(subpath) ? `DONE${!product?.msrp ? ` - ${product?.price}` : ''}` : `Done${!product?.msrp ? ` - ${product?.price}` : ''}`}
                </button>
              </If>
              <If condition={['rogers-jewelry','daniels-jewelers','daniels-jewelers-dev', 'awardco'].includes(subpath)}>
                <div className='tw-flex tw-items-center tw-justify-between tw-px-3 tw-h-13 tw-w-full tw-top-0 tw-bg-primary-bg-color sm:tw-hidden'>
                  <button className="!tw-bg-brand-color !tw-text-white tw-px-4 tw-py-2 tw-text-sm secondary-font-family tw-rounded-tertiary-border-radius" onClick={handleActiveTab?.("summary", false)}>
                    Done - {product?.price}
                  </button>
                </div>
              </If>
              <If condition={['tqDiamonds', 'tqDiamonds-stage'].includes(subpath)}>
                <button className="!tw-bg-brand-color !tw-text-white tw-px-4 tw-py-2 tw-text-sm secondary-font-family tw-rounded-tertiary-border-radius" onClick={handleDone}>
                  Add to Cart -  {product?.price}
                </button>
              </If>
            </div>
            <If condition={!!product?.msrp}>
            <div className={clsx('sm:tw-hidden tw-flex tw-items-center tw-px-3 tw-pb-2 tw-w-full tw-top-0 tw-bg-primary-bg-color tw-justify-center tw-flex-col secondary-font-family')}>
              <div className='tw-flex tw-justify-center tw-flex-row tw-w-full secondary-font-family tw-text-sm'>
                <p className='tw-flex tw-justify-center tw-items-center tw-gap-3 tw-w-full tw-px-1 tw-pt-1 tw-mx-1'>
                  <strong>MSRP:</strong>
                  <span className='tw-line-through tw-text-gray-500'>{product?.msrp}</span>
                </p>
                <p className='tw-flex tw-justify-center tw-items-center tw-gap-3 tw-w-full tw-px-1 tw-pt-1 tw-mx-1 tw-text-sm'>
                  <strong>OUR PRICE:</strong>
                  <span>{product?.price}</span>
                </p>
              </div>
            </div>
          </If>
          </If>
          <If condition={styles.saleDiscount > 0}>
            <div className={clsx('sm:tw-hidden tw-flex tw-items-center tw-px-3 tw-pt-2 tw-w-full tw-top-0 tw-bg-primary-bg-color tw-justify-center tw-flex-col secondary-font-family')}>
              <button className="!tw-bg-brand-color !tw-text-white tw-px-4 tw-py-2 tw-text-sm secondary-font-family tw-rounded-tertiary-border-radius" onClick={handleDone}>
                Finish Your Design
              </button>
              <div className='tw-flex tw-justify-center tw-flex-row tw-flex-1 secondary-font-family'>
                <p className='tw-flex tw-justify-center tw-items-center tw-gap-3 tw-w-full tw-px-1 tw-pt-1 tw-mx-1'>
                  <span className="tw-text-lg tw-text-center">
                    {(() => { const n = Number(String(product?.price ?? '').replace(/[^\d.-]/g,'')); return Number.isFinite(n) && new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n * (1 - styles.saleDiscount / 100)); })()}
                  </span>
                </p>
                <p className='tw-flex tw-justify-center tw-items-center tw-gap-3 tw-w-full tw-px-1 tw-pt-1 tw-mx-1'>
                  <span className='tw-text-lg tw-line-through tw-text-gray-500'>{product?.price}</span>
                </p>
              </div>
            </div>
            <div className='tw-text-center tw-bg-primary-bg-color sm:tw-hidden currency-message secondary-font-family tw-pb-1'>
              <div>*Pricing is shown in USD</div>
            </div>
          </If>
					<If condition={['shaneco', 'shaneco-pos'].includes(subpath)}>
          <div className="pricing-norefund-acceptance tw-text-center md:tw-hidden">
              <div className="disclaimer-text tw-my-2">
                All custom ring purchases are final and cannot be returned.
              </div>
              <label className="disclaimer-input">
                <input
                  className="tw-mr-3"
                  type="checkbox"
                  value="I understand"
                  onClick={e => setAcknowledged(e.currentTarget.checked )}
                />
                I understand
              </label>
            </div>
            <If condition={acknowledged}>
              <button className='!tw-bg-brand-color !tw-text-white tw-w-full tw-px-9 tw-py-2 tw-font-medium tw-mx-auto sm:tw-hidden shaneco-button' onClick={handleDone}>
                ADD TO BAG
              </button>
            </If>
            <If condition={!acknowledged}>
              <button className='!tw-bg-brand-color !tw-text-white tw-w-full tw-px-9 tw-py-2 tw-font-medium tw-mx-auto sm:tw-hidden shaneco-button disabled' onClick={handleDone} disabled>
                ADD TO BAG
              </button>
            </If>
          </If>
        </If>
        <If condition={['mavilo', 'mavilo-stage'].includes(subpath)}>
          <div className='tw-flex tw-items-center tw-px-3 tw-h-13 tw-w-full tw-top-0 tw-bg-primary-bg-color sm:tw-hidden'>
            <button className='!tw-bg-brand-color !tw-text-white tw-mx-auto tw-px-4 tw-py-2 tw-text-sm secondary-font-family tw-rounded-tertiary-border-radius' onClick={handleDone}>
              Connect
            </button>
          </div>
          <div className='tw-flex tw-items-center tw-px-3 tw-h-7 tw-w-full tw-top-0 tw-bg-primary-bg-color sm:tw-hidden'>
            Retail
            <span className={clsx('tw-px-4 tw-text-center sidebar-value', {
              'mavilo-price': ['mavilo', 'mavilo-stage'].includes(subpath),
            })}>
              {product?.price}
            </span>
          </div>
          <div className='tw-flex tw-items-center tw-h-7 tw-justify-between tw-px-3 tw-w-full tw-top-0 tw-bg-primary-bg-color sm:tw-hidden'>
            Mavilo Discounts Apply
          </div>
          <div className='tw-flex tw-items-center tw-h-7 tw-justify-between tw-px-3 tw-w-full tw-top-0 tw-bg-primary-bg-color sm:tw-hidden'>
            Style Number: {product?.magic_number}
          </div>
          <div className='tw-flex tw-items-center tw-h-7 tw-justify-between tw-px-3 tw-w-full tw-top-0 tw-bg-primary-bg-color sm:tw-hidden'>
            Size: {selectedSize?.name}
          </div>
        </If>
      </>)
  }

  const handleEngravingReversePattern = () => {
    const { selectedOption } = engravingInfo;
    if (selectedOption.is_reverse_selected) {
        handleUpdate({ engraving_pattern: selectedOption.sku });
    } else {
        handleUpdate({ engraving_pattern: `${selectedOption.sku}REV` });
    }
};

const handleLogoReversePattern = () => {
    const { selectedOption } = SignetEngravingInfo;
    if (selectedOption.is_reverse_selected) {
        handleUpdate({ signet_engraving: selectedOption.sku });
    } else {
        handleUpdate({ signet_engraving: `${selectedOption.sku}REV` });
    }
};

const handleClose = () => {
    setDiscountOpen(false);
    if (params.otherQueryParams) {
      delete params.otherQueryParams.bestSeller;
    }
    navigateToUrl(bProduct?.ring_options_url, true);
};

const formatPriceOnlyStripDot00 = (value: any) => {
  if (value == null) return '';
  const raw = String(value).trim();

  // preserve any leading currency/symbols (e.g. "$")
  const prefix = raw.match(/^[^\d-]+/)?.[0] ?? '';

  // get a numeric value from the rest
  const num = parseFloat(raw.replace(/[^\d.-]/g, ''));
  if (!Number.isFinite(num)) return raw; // fallback

  const fixed = num.toFixed(2);

  // if it's exactly .00, print as integer; otherwise keep two decimals
  const formatted = fixed.endsWith('.00')
    ? new Intl.NumberFormat(undefined, { maximumFractionDigits: 0, useGrouping: false }).format(num)
    : new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: false }).format(num);

  return prefix + formatted;
};

const selectedPage = pages.find(item => item.eventKey === key);
const engravingInfo = key === 'engraving' ? getSelectedInfo(selectedPage) : null;
const SignetEngravingInfo = key === 'logo' || key === 'outsideFeature_1' ? getSelectedInfo(selectedPage) : null;

  return (<div className="tw-flex tw-flex-col app-container">
    <RingCustomizerLayout />
    {renderTopBar()}
    <If condition={['legacy-touch-dev', 'legacy-touch'].includes(subpath)}>
      <LegacyTouchIntroModal />
    </If>
    <div className="main_container tw-flex-1 tw-flex tw-flex-wrap secondary-font-family">
      <DesktopSidebar pages={pages} selectedTab={key} handleActiveTab={handleActiveTab} price={product?.price} shippingOptions={product?.shipping_options}/>
      <div className="tw-flex-1 tw-flex tw-flex-col tw-w-0 tw-h-full">
        {/* Gallery */}
        <If condition={['legacy-touch-dev', 'legacy-touch'].includes(subpath)}>
          <div className="tw-text-center lg:tw-pt-10" style={{fontSize: '25.6px', color: '#52525B', fontWeight: '300'}}>
            <button
              onClick={handleLogoClick}
              className="tw-text-inherit tw-bg-transparent tw-border-0 tw-cursor-pointer tw-flex tw-mx-auto"
            >
              Legacy Touch Memorial Ring
            </button>
          </div>

          <div className={clsx("tw-text-center primary-font-family legacy-sub-title desktop-hide tw-italic")}>
            Hand-crafted and personalized
          </div>
          <div className={clsx("tw-text-center tw-text-lg primary-font-family tw-text-primary-color tw-flex desktop-hide")} style={{justifyContent: "center"}}>
            <button
              // onClick={() => setActiveModal('reviews')}
              className="tw-text-inherit tw-bg-transparent tw-border-0 tw-cursor-pointer tw-flex"
              style={{justifyContent: "center"}}
            >
              <div className="tw-flex legacy-stars-container">
                <svg className="legacy-star" width="17" height="16" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9344 0.40332L13.293 7.66847H20.9325L14.7523 12.1574L17.1109 19.4226L10.9306 14.9336L4.75037 19.4226L7.10895 12.1574L0.928711 7.66847H8.56823L10.9344 0.40332Z" fill="#2574BB"/>
                </svg>
                <svg className="legacy-star" width="17" height="16" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9344 0.40332L13.293 7.66847H20.9325L14.7523 12.1574L17.1109 19.4226L10.9306 14.9336L4.75037 19.4226L7.10895 12.1574L0.928711 7.66847H8.56823L10.9344 0.40332Z" fill="#2574BB"/>
                </svg>
                <svg className="legacy-star" width="17" height="16" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9344 0.40332L13.293 7.66847H20.9325L14.7523 12.1574L17.1109 19.4226L10.9306 14.9336L4.75037 19.4226L7.10895 12.1574L0.928711 7.66847H8.56823L10.9344 0.40332Z" fill="#2574BB"/>
                </svg>
                <svg className="legacy-star" width="17" height="16" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9344 0.40332L13.293 7.66847H20.9325L14.7523 12.1574L17.1109 19.4226L10.9306 14.9336L4.75037 19.4226L7.10895 12.1574L0.928711 7.66847H8.56823L10.9344 0.40332Z" fill="#2574BB"/>
                </svg>
                <svg className="legacy-star" width="17" height="16" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9344 0.40332L13.293 7.66847H20.9325L14.7523 12.1574L17.1109 19.4226L10.9306 14.9336L4.75037 19.4226L7.10895 12.1574L0.928711 7.66847H8.56823L10.9344 0.40332Z" fill="#2574BB"/>
                </svg>
              </div>
              <div className="legacy-review-count">
                316 Reviews
              </div>
            </button>
          </div>
        </If>
        <div className={clsx("gallery_container tw-relative tw-pt-1 lg:tw-pt-10", {'sm:tw-hidden': ['summaryInfo', 'summary'].includes(key)}, subpath)}>
          <MyGallery images={product?.images || []}/>
          <div className="tw-absolute tw-bottom-1 tw-text-center tw-cursor-pointer tw-left-3 sm:tw-left-6 lg:tw-left-20 tw-flex xs:tw-flex-col lg:tw-flex-row xs:tw-gap-2 lg:tw-gap-5 secondary-font-family">
            <If condition={myHistory.length}>
                  <div onClick={handleUndo} role="presentation">
                      <img src={undoIcon} alt="undo_icon" className="tw-inline-block width-20" />
                      <div className="tw-underline tw-text-gray-600 tw-text-sm">Undo</div>
                  </div>
                  <div onClick={handleReset} role="presentation">
                      <img src={refreshIcon} alt="undo_icon" className="tw-inline-block tw-w-6" />
                      <div className="tw-underline tw-text-gray-600 tw-text-sm tw-m-0.5">Reset</div>
                  </div>
            </If>
            <If condition={key === 'engraving' && engravingInfo?.selectedOption?.has_inside_reversed_option}>
                <div onClick={handleEngravingReversePattern} role="presentation">
                  <img src={ReverseIcon} alt="undo_icon" className="tw-inline-block tw-w-6" />
                  <div className="tw-underline tw-text-gray-600 tw-text-sm tw-m-0.5">Reverse <br />Pattern</div>
                </div>
              </If>
            <If condition={(key === 'logo' || key === 'outsideFeature_1') && SignetEngravingInfo?.selectedOption?.has_outside_reversed_option}>
              <div onClick={handleLogoReversePattern} role="presentation">
                <img src={ReverseIcon} alt="undo_icon" className="tw-inline-block tw-w-6" />
                <div className="tw-underline tw-text-gray-600 tw-text-sm tw-m-0.5">Reverse <br />Pattern</div>
              </div>
            </If>
          </div>

        </div>
        {/* Customize container */}
        <div className={clsx(`tw-relative customizer_container tw-flex-1 tw-flex tw-flex-col ${key} ${subpath}`)}>
          <div id="main-content" className={clsx('tw-flex-1', { 'hidden': open }, { 'legacy-touch': ['legacy-touch', 'legacy-touch-dev'].includes(subpath)})}>
            {pages.length > 0 &&
                <AppTabs
                    tabs={pages}
                    tabStyle="single"
                    onChange={handleUpdate}
                    isFetching={isLoading}
                    activeKey={key}
                    onChangeParentActiveKey={setKey}
                    onSidebarChange={setKey}
                    images={product?.images}
                />}
          </div>
          {!open && <div className="tw-absolute tw-left-3 tw-top-3 tw-cursor-pointer sm:tw-hidden" onClick={toggleOpen}>
            <img src={listIcon} alt="list_icon" className="tw-inline"/>
            {/* <span className='tw-text-base tw-font-bold tw-ml-3 tw-text-primary-color'>All Steps</span> */}
          </div>}
          <AppModal size='lg' isOpen={open} onClose={toggleOpen} hideCloseIcon={true}>
            <MobileSidebar
              pages={pages}
              selectedTab={key}
              handleActiveTab={handleActiveTab}
              toggleOpen={toggleOpen}
              price={product?.price}
            />
          </AppModal>
        </div>
      </div>
    </div>
    <If condition={['kay-jewelers', 'diamonds-direct'].includes(subpath)}>
      <div className={clsx('tw-flex tw-items-center tw-px-3 tw-h-13 tw-w-full tw-top-0 tw-justify-between sm:tw-hidden')} style={{ backgroundColor: "#fafafa"}}>
        <div className='tw-text-center tw-text-sm'>
          <div>Ships as soon as:</div>
          <div className='tw-font-bold'>{formatSummaryDate(product?.shipping_options?.standard)}</div>
        </div>
        <div className='tw-text-center'>
          {product?.price}
        </div>
      </div>
    </If>
    <If condition={['legacy-touch', 'legacy-touch-dev'].includes(subpath)}>
      <div className={clsx('tw-flex tw-items-center tw-px-3 tw-w-full tw-top-0 tw-bg-primary-bg-color sm:tw-hidden tw-justify-center tw-flex-col')}>
        <div style={{marginLeft: "12px", color: "rgb(82, 82, 91)", width: "100%", padding: "10px 0"}}>
          <div style={{fontSize: '14px', fontWeight: '600'}}>Usually ships within 2 weeks</div>
        </div>
        <button className="!tw-bg-brand-color !tw-text-white tw-px-4 tw-py-2 tw-text-sm secondary-font-family tw-rounded-tertiary-border-radius" style={{width: "calc(100% - 130px)", marginRight: "auto", marginBottom: "10px"}} onClick={() => handleLegacyAddToCart({ isMobile: true })}>
          Add to Cart - {formatPriceOnlyStripDot00(product?.price)}
        </button>
      </div>
    </If>
    <AppModal size="xxl" isOpen={discountOpen && !['kay-jewelers', 'kay-jewelers-stage'].includes(subpath)} onClose={handleClose}>
      <DiscountedPopup
        id={bestSellerId}
        engraving={engraving}
        setEngraving={setEngraving}
        size={size}
        setSize={setSize}
        // handleBestSeller={handleBestSeller}
        handleBestSellerDone={handleBestSellerDone}
        isBestSellerLoading={isBestSellerLoading}
        product={product}
        navigateToUrl={navigateToUrl}
        onClose={handleClose}
      />
    </AppModal>
    <AppModal size="custom" isOpen={discountOpen && ['kay-jewelers', 'kay-jewelers-stage'].includes(subpath)} onClose={handleClose}
      customClassName="kay-discount-modal">
      <KayDiscountedPopup
        id={bestSellerId}
        engraving={engraving}
        setEngraving={setEngraving}
        size={size}
        setSize={setSize}
        handleBestSellerDone={handleBestSellerDone}
        product={product}
        navigateToUrl={navigateToUrl}
        onClose={handleClose}
      />
    </AppModal>
    {inactivityModalOpen && screensaverData?.active && screensaverData?.video_path && (
      <div
        className="screensaver-overlay"
        onClick={closeInactivityModal}
        role="presentation"
        style={{
          transition: `opacity ${SCREENSAVER_CONFIG.FADE_DURATION}ms ease-in-out`,
          opacity: isFading ? 0 : 1,
        }}
      >
        <video
          ref={videoRef}
          src={`${screensaverData.video_path}${screensaverData.video_path.indexOf('?') !== -1 ? '&' : '?'}rand=${Math.random().toString(12)}`}
          autoPlay
          muted
          loop
          playsInline
          onError={(e) => console.error('Screensaver video failed to load:', e)}
          className="screensaver-video"
        />
        <div className="tw-absolute tw-bottom-8 tw-left-1/2 tw-transform tw--translate-x-1/2 tw-text-white tw-text-sm tw-opacity-70 tw-z-10">
          Click anywhere to continue
        </div>
      </div>
    )}
    <Loader timedOut={isLoading}/>
  </div>)
}

export default RingCustomizerHOC(RingCustomizer);

/*useEffect(() => {
  console.log('>>>>>>LOCATION>>>>>>>>>>>>>>>>>>>>>>>', location);
  console.log('>>>>>>PARAMS>>>>>>>>>>>>>>>>>>>>>>>>>', params);
  console.log('>>>>>>SEARCH PARAMS ENTRIES>>>>>>>>>>', Object.fromEntries(searchParams.entries()));
  console.log('>>>>>>SEARCH PARAMS toString()>>>>>>>', searchParams.toString());
  console.log('>>>>>>SEARCH PARAMS Get>>>>>>>>>>>>>>', searchParams.get('finish_type'));
  return () => console.log('>>>UN MOUNT>>>',)
}, [])*/
